import type { ReactNode } from 'react';
import { Outlet } from 'react-router';

import { useCurrentUser } from './useCurrentUser';

export interface RequirePlatformAdminProps {
  /** Rendered when the check fails. Defaults to nothing, which is right for a button. */
  fallback?: ReactNode;
  /** Omit to use this as a route element, where it renders an <Outlet />. */
  children?: ReactNode;
}

/**
 * The platform-administrator twin of `RequireRole`.
 *
 * <p>Separate rather than a fifth role, because it is not one: a platform admin is a
 * property of the PERSON, held across every organization, while a role belongs to one
 * membership. Folding it into the hierarchy would make "OWNER of Acme" and "operator of
 * the whole platform" comparable, which they are not.
 *
 * <p>UX, not security. Every `/platform` endpoint refuses a non-admin server-side.
 */
export function RequirePlatformAdmin({ fallback = null, children }: RequirePlatformAdminProps) {
  const me = useCurrentUser();

  if (!me.platformAdmin) return <>{fallback}</>;
  return <>{children ?? <Outlet />}</>;
}
